var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.show)?_c('div',{staticClass:"loader"},[(_vm.showIcon)?_c('div',{class:_vm.iconClass}):_vm._e(),_c('div',{staticClass:"loader__spinner"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }